module.exports = __webpack_public_path__ + "static/media/201IT103.cf8e30f7.jpg";